/* global Tena */

(function($) {
    'use strict';

    var Menu = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$trigger = this.$el.find('.mobile-menu-trigger');
        this.$header = this.$el.find('.mobile-menu-top');
        this.$content = this.$el.find('.mobile-menu-content-wrapper');

        this.settings = $.extend(
            {
                speed: 200,
                side: 'left'
            },
            this.settings
        );

        this.init();
    };

    Menu.prototype = {
        width: null,
        height: null,
        isOpen: false,
        $cover: null,
        documentWidth: $(document).width(),

        init: function() {
            this.width = this.$el.width();
            this.height = $(window).height();

            if ($(window).width() <= 400) {
                this.width = $(window).width() - 60;
            } else if ($(window).width() > 400) {
                this.width = 320;
            }

            if (this.settings.side === 'left') {
                this.$el.width(this.width).css('left', -this.width);
            } else {
                this.$el.width(this.width).css('right', -this.width);
            }

            this.$content.height(this.height - 60);

            this.addCover();
            this.bindEvents();

            if (!Tena.browser.ie7) {
                this.$el.find('select').selectOrDie();
            }
        },

        bindEvents: function() {
            var that = this;

            that.$trigger.on('click', function(e) {
                if (that.isOpen) {
                    that.hide();
                } else {
                    that.show();
                }
                e.preventDefault();
            });

            that.$el.find('.submenu-trigger').on('click', function() {
                var $trigger = $(this),
                    $list = $trigger.parent(),
                    $submenu = $list.find('.submenu');

                if ($list.parent().hasClass('expanded-submenu')) {
                    return;
                }

                if ($submenu.is(':hidden')) {
                    $list.addClass('active');
                    $submenu.show();
                } else {
                    $list.removeClass('active');
                    $submenu.hide();
                }

                return false;
            });

            that.$cover.on('click', function() {
                that.hide();
            });

            $(window).resize(function() {
                that.$content.height($(window).height());
                if ($(document).width() !== that.documentWidth) {
                    that.documentWidth = $(document).width();
                    if (that.isOpen) {
                        that.hide();
                        $('.viewport').css('width', 'auto');
                        $('.wrapper').css({
                            width: 'auto',
                            left: 0
                        });
                    }
                    that.$el.width(that.width);
                    that.documentWidth = $(document).width();
                }
            });

            $('.mobile-menu-search-submit').on('click', function(e) {
                var $submit = $(this),
                    $field = $('.mobile-menu-search-field');

                if ($field.is(':hidden')) {
                    $field.css('display', 'block');
                    $submit.css({
                        left: that.width - 80,
                        color: '#fff'
                    });
                    $field.focus();

                    e.preventDefault();
                }
            });
        },

        addCover: function() {
            this.$cover = $('<div>').addClass('mobile-menu-cover');
            this.$cover.height($('body').height() + 60);
            $('.viewport').append(this.$cover);
        },

        cover: function(action) {
            var that = this,
                $cover = that.$cover,
                settings = { duration: that.settings.speed, queue: false };

            if (action === 'show') {
                $cover.fadeIn(settings);
            } else {
                $cover.fadeOut(settings);
            }
        },

        closeOtherMenus: function() {
            $('.mobile-menu').not(this.$el).menu('hide');
        },

        show: function() {
            var that = this,
                $wrapper = $('.wrapper'),
                $viewport = $('.viewport'),
                css = {};

            that.isOpen = true;
            that.closeOtherMenus();
            that.cover('show');
            that.$el.addClass('active');

            $wrapper
                .css({
                    top: -$('body').scrollTop()
                })
                .data('scrollPosition', $('body').scrollTop());
            $viewport.css({
                position: 'fixed',
                height: $(window).height() - 60
            });

            if (that.settings.side === 'left') {
                css.left = 0;
            } else {
                css.right = 0;
            }

            that.$el.css(css);
        },

        hide: function() {
            var that = this,
                $wrapper = $('.wrapper'),
                $viewport = $('.viewport'),
                css = {};

            if (!that.isOpen) {
                return;
            }

            that.isOpen = false;
            that.cover('hide');
            that.$el.removeClass('active');

            if (that.settings.side === 'left') {
                css.left = -this.width;
            } else {
                css.right = -this.width;
            }

            that.$el.css(css);

            $wrapper.css({
                top: 0
            });
            $viewport.css({
                position: 'initial',
                height: 'auto'
            });
            $('body').scrollTop($wrapper.data('scrollPosition'));
        }
    };

    $.fn.menu = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('menu');

            if (!data) {
                $this.data('menu', (data = new Menu(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.menu.Constructor = Menu;
})(jQuery);
